export function ComingSoon() {
  return (
    <div className="flex items-center justify-center h-64">
      <p className="text-[#9295A5] text-base">Coming soon</p>
    </div>
  );
}
